import { Row, Space, Typography, Table } from "antd"
import { useEffect, useState } from "react"
import { useRecoilValue, useRecoilState } from "recoil"
import { useNavigate } from "react-router-dom"
import { allSitesAtom } from "../../Atoms/allSitesAtom"
import { useCookies } from 'react-cookie';
import { useAuthenticator } from '@aws-amplify/ui-react'
import "./Dashboard.css"
import _ from 'lodash'

function Dashboard() {
  const navigate = useNavigate();
  const allSites = useRecoilValue(allSitesAtom)
  const { user } = useAuthenticator((context) => [context.user]);
  let email = ''
  if(user?.attributes?.email) email = user?.attributes?.email
  const [cookies, setCookie] = useCookies([email]);
  const { Title } = Typography;
  useEffect(() => {
    if(user && _.has(user,'signInUserSession')) navigate(`/stores`)
  }, [allSites,cookies,user]);

  return (
    <>
    </>
  );
}

export default Dashboard;